// assets/js/ui-swal.js
(function (root, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = factory(
      require("sweetalert2").default || require("sweetalert2")
    );
  } else {
    root.UIAlerts = factory(root.Swal);
  }
})(typeof self !== "undefined" ? self : this, function (Swal) {
  if (!Swal)
    throw new Error(
      "SweetAlert2 (Swal) not found. Import it before ui-swal.js"
    );

  const baseClasses = {
    popup: "swal--popup",
    title: "swal--title",
    htmlContainer: "swal--content",
    actions: "swal--actions",
    confirmButton: "swal-btn swal-btn--primary",
    cancelButton: "swal-btn swal-btn--secondary",
  };

  const variantClass = (name = "primary") => `swal-btn swal-btn--${name}`;

  /** Generic alert with button variants */
  function alert(options = {}) {
    const {
      title,
      text,
      html,
      icon, // 'success' | 'error' | 'warning' | 'info' | 'question'
      showCancelButton = false,
      confirmVariant = "primary",
      cancelVariant = "secondary",
      ...rest
    } = options;

    return Swal.fire({
      title,
      text,
      html,
      icon,
      showCancelButton,
      buttonsStyling: false,
      customClass: {
        ...baseClasses,
        confirmButton: variantClass(confirmVariant),
        cancelButton: variantClass(cancelVariant),
      },
      ...rest,
    });
  }

  /** Opinionated confirm */
  function confirm(opts = {}) {
    return alert({
      icon: "warning",
      title: "Are you sure?",
      text: "This action cannot be undone.",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel",
      confirmVariant: "danger",
      cancelVariant: "secondary",
      ...opts,
    });
  }

  /** Toast with optional custom bg/fg (CSS vars) */
  function toast(opts = {}) {
    const {
      title,
      icon = "success",
      position = "top-end",
      timer = 2600,
      showConfirmButton = false,
      background, // e.g. 'linear-gradient(90deg,#0b1b07,#133a12)'
      color, // text color override (optional)
      ...rest
    } = opts;

    return Swal.fire({
      toast: true,
      title,
      icon,
      position,
      timer,
      showConfirmButton,
      buttonsStyling: false,
      customClass: { popup: "swal-toast" },
      didOpen: (el) => {
        if (background) el.style.setProperty("--swal-toast-bg", background);
        if (color) el.style.setProperty("--swal-toast-fg", color);
      },
      ...rest,
    });
  }

  return { alert, confirm, toast };
});
